import URLConfig from '@Config/urls/url.config';
import { Route } from 'react-router-dom';
import * as ArchivingModulePages from '@Modules/admin/archiving/pages';
import * as TransactionHistoryPages from '@Modules/admin/archiving/pages/archivedTables/validTransactionInquiryHistory';
import * as consultationAuthorizationsDetails from '@Modules/admin/archiving/pages/archivedTables/consultationAuthorizationsDetails';
import ATMTransactionInquiryDetailsPage from '@Modules/admin/archiving/pages/archivedTables/atmTransactionInquiryDetails/ATMTransactionInquiryDetailsPage';
const archivingRoutes = [
  <Route
    path={URLConfig.ADMIN.ARCHIVING.SETTINGS}
    element={<ArchivingModulePages.ArchivingSettingsPage />}
  />,

  // Batches menu
  <Route
    path={URLConfig.ADMIN.ARCHIVING.BATCHES_MENU.ROOT}
    element={<ArchivingModulePages.BatchesMenuLayout />}
  >
    <Route
      path={URLConfig.ADMIN.ARCHIVING.BATCHES_MENU.SUPERVISION_OF_BATCHES}
      element={<ArchivingModulePages.BatchesSupervisionPage />}
    />
    ,
    <Route
      path={URLConfig.ADMIN.ARCHIVING.BATCHES_MENU.PURGE_SETTINGS}
      element={<ArchivingModulePages.PurgeSettingsPage />}
    />
  </Route>,

  // Archived Tables menu
  <Route
    path={URLConfig.ADMIN.ARCHIVING.ARCHIVED_TABLES_MENU.ROOT}
    element={<ArchivingModulePages.ArchivedTablesMenuLayout />}
  >
    <Route
      path={
        URLConfig.ADMIN.ARCHIVING.ARCHIVED_TABLES_MENU.VALID_TRANSACTION_INQUIRY
      }
      element={<ArchivingModulePages.ValidTransactionInquiryPage />}
    />
    ,
    <Route
      path={
        URLConfig.ADMIN.ARCHIVING.ARCHIVED_TABLES_MENU
          .VALID_TRANSACTION_INQUIRY_HISTORY + ':id/'
      }
      element={<ArchivingModulePages.ValidTransactionInquiryHistoryLayout />}
    >
      <Route path={'amount'} element={<TransactionHistoryPages.AmountPage />} />
      <Route
        path={'carrier'}
        element={<TransactionHistoryPages.CarrierPage />}
      />
      <Route
        path={'emv-data'}
        element={<TransactionHistoryPages.EMVDataPage />}
      />
      <Route
        path={'indicator'}
        element={<TransactionHistoryPages.IndicatorPage />}
      />
      <Route
        index
        path={'transaction'}
        element={<TransactionHistoryPages.TransactionPage />}
      />
      <Route
        path={'tvr-cvr'}
        element={<TransactionHistoryPages.TVRCVRPage />}
      />
    </Route>
    ,
    <Route
      path={
        URLConfig.ADMIN.ARCHIVING.ARCHIVED_TABLES_MENU
          .CONSULTATION_OF_AUTHORIZATIONS
      }
      element={<ArchivingModulePages.ConsultationAuthorizationsPage />}
    />
    <Route
      path={
        URLConfig.ADMIN.ARCHIVING.ARCHIVED_TABLES_MENU
          .CONSULTATION_OF_AUTHORIZATIONS_DETAILS + ':id/'
      }
      element={<ArchivingModulePages.ConsultationAuthorizationsDetailsLayout />}
    >
      <Route 
        path={'amount'} 
        element={<consultationAuthorizationsDetails.AmountPage />} 
      />
      <Route
        path={'cardholder'}
        element={<consultationAuthorizationsDetails.CardholderPage />}
      />
      <Route
        path={'emv-data'}
        element={<consultationAuthorizationsDetails.EMVDataPage />}
      />
      <Route
        index
        path={'main-data'}
        element={<consultationAuthorizationsDetails.MainDataPage />}
      />
      <Route        
        path={'merchant'}
        element={<consultationAuthorizationsDetails.MerchantPage />}
      />
      <Route 
        path={'miscellaneous'} 
        element={<consultationAuthorizationsDetails.MiscellaneousPage />} 
      />
      <Route
        path={'original-data'}
        element={<consultationAuthorizationsDetails.OriginalDataPage />}
      />
      <Route
        path={'pos-entry-mode-code'}
        element={<consultationAuthorizationsDetails.POSEntryModePage />}
      />
      <Route
        path={'response-code'}
        element={<consultationAuthorizationsDetails.ResponseCodePage />}
      />
      <Route
        path={'tvr-cvr'}
        element={<consultationAuthorizationsDetails.TVRCVRPage />}
      />
    </Route>
    <Route
      path={
        URLConfig.ADMIN.ARCHIVING.ARCHIVED_TABLES_MENU.ATM_TRANSACTION_INQUIRY
      }
      element={<ArchivingModulePages.AtmTransactionInquiryPage />}
    />
    <Route
      path={
        URLConfig.ADMIN.ARCHIVING.ARCHIVED_TABLES_MENU.ATM_TRANSACTION_INQUIRY_DETAILS + ':id/'
      }
      element={<ATMTransactionInquiryDetailsPage />}
    />
    
  </Route>,
];

export default archivingRoutes;
